import { useMemo } from 'react';
import { ShieldCheck } from 'lucide-react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const SCAN_STATUS_OPTIONS = [
  { id: 'CLEAN', value: 'CLEAN', label: 'Clean' },
  { id: 'PENDING', value: 'PENDING', label: 'Pending' },
  { id: 'SCANNING', value: 'SCANNING', label: 'Scanning' },
  { id: 'INFECTED', value: 'INFECTED', label: 'Infected' },
  { id: 'FAILED', value: 'FAILED', label: 'Failed' },
];

export function ScanStatusFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selected = useMemo(() => {
    const scanStatus = filters['scanStatus'] ?? [];
    const validIds = new Set(SCAN_STATUS_OPTIONS.map(({ id }) => id));
    return scanStatus.filter((id: string) => validIds.has(id));
  }, [filters]);

  return (
    <MultipleChoiceFilter
      items={SCAN_STATUS_OPTIONS}
      label="Scan Status"
      name="scanStatus"
      onFilterChange={({ scanStatus }) => updateFilters({ scanStatus })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<ShieldCheck size={iconSize.md} />}
      rightIcon={undefined}
    />
  );
}
